const reputationAdvancedNewPermissions = (
  action,
  permissions,
  institutionId,
) => {
  if (action === 'reputation_advanced_new:view_tableau_dashboard' &&
    institutionId in permissions &&
    permissions[institutionId].some(item => item.match(/^REPUTATION_ADVANCED_NEW_[0-9]{4}$/))
  ) {
    return true;
  }

  return false;
};

module.exports = {
  reputationAdvancedNewPermissions,
};
